export default __webpack_public_path__ + "static/media/LAS0830.34I-38574_-22596_0.8d01df2f.jpg";